import { useRef } from "react";

import DayOne from "./components/DayOne";
import DayTwo from "./components/DayTwo";
import Footer from "./components/Footer";
import Header from "./components/Header";

const App = () => {
  const contentRef = useRef();

  const handleClick = () => {
    contentRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="app">
      <Header handleClick={handleClick} />
      <DayOne ref={contentRef} />
      <DayTwo />
      <Footer />
    </div>
  );
};

export default App;
